import { Table } from '@devexpress/dx-react-grid-material-ui';
import makeStyles from '@mui/styles/makeStyles';
import CellComponentStyles from '../Cell.styles';
import NRNoDataPresentComponent from '../../NRNoDataPresentComponent/NRNoDataPresentComponent';
import NRLoader from '../../NRLoader/NRLoader';
import { forwardRef, memo } from 'react';
import clsx from 'clsx';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/styles';
const useStyles = makeStyles(CellComponentStyles);

export const EMPTY_CELL_VALUE = '-';

export const NRHandleEmptyCellValue = forwardRef(({ value }, ref) => {
  const classes = useStyles();
  return (
    <span ref={ref} className={clsx({ [classes.emptyCell]: !value })}>
      {!!value ? value : EMPTY_CELL_VALUE}
    </span>
  );
});

export const CellComponent = props => {
  const theme = useTheme();
  const { column, value, row } = props;
  const classes = useStyles();
  if (!column.isLast) {
    return (
      <Table.Cell
        {...props}
        data-nr-col={column?.name}
        value={<NRHandleEmptyCellValue value={value} />}
        style={{
          ...props.style,
          borderLeft: 'unset',
          borderRight: 'unset',
          ...(column.name !== 'info'
            ? column.name === 'cve' || (column.name === 'name' && Object.keys(row).includes('dependency'))
              ? { padding: theme.spacing(0), position: 'relative' }
              : { padding: theme.spacing(1.25, 2) }
            : { padding: theme.spacing(0.5, 0) }),
          ...(!!column.actions && { textOverflow: 'unset' })
        }}
        className={classes.focusedBorder}
      />
    );
  }
  return (
    <Table.Cell
      {...props}
      data-nr-col={column?.name}
      style={{ ...props.style, padding: theme.spacing(1.25, 2), borderLeft: 'unset', borderRight: 'unset' }}
    >
      <NRHandleEmptyCellValue value={value} />
    </Table.Cell>
  );
};

const MemoizedNRLoader = memo(() => <NRLoader />);

export const NoDataCellComponent = memo(({ loading, noDataComponent, ...props }) => {
  const theme = useTheme();
  return (
    <Table.Cell {...props}>
      <Box
        sx={{
          padding: theme.spacing(10, 0),
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        {!loading && <NRNoDataPresentComponent />}
        {!!loading && <MemoizedNRLoader />}
        {noDataComponent}
      </Box>
    </Table.Cell>
  );
});
